import React from 'react';

import SetDeleteTrplBtns from './SetDeleteTrplBtns';
import GoogleMap from '../../GoogleMap';
import CreateTrplBtn from './CreateTrplBtn';

export default ({ 
  rst,
  trpls,
  type,
  groupId,
  classes,
  setTrpl,
  constant,
  isNewNode,
  ancestorId,
  loadingTids,
  deletedTids,
  isAnotherNode,
  hideSetDelete,
  setLoadingTids,
  removeTrplValue,
  setDeletedTrplId,
  resetDeletedTrplId,
  disableTrplEditing,
  updateDataOnRestoreTrpl,
}) => {
  const [trpl] = trpls;

  const locationJSON = trpl.metadata && trpl.metadata._val ? trpl.metadata._val : null;

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'flex-end'
      }}
    >
      {locationJSON &&
        <GoogleMap
          isMarkerShown
          locations={{
            origin: {
              lat: locationJSON.latitude,
              lng: locationJSON.longitude,
            },
          }}
        />
      }

      {hideSetDelete ? null : trpl.tid ?
        <SetDeleteTrplBtns
            rst={rst}
            type={type}
            trpl={trpl}
            trplIndex={0}
            groupId={groupId}
            classes={classes}
            setTrpl={setTrpl}
            ancestorId={ancestorId}
            loadingTids={loadingTids}
            isAnotherNode={isAnotherNode}
            removeTrplValue={removeTrplValue}
            setLoadingTids={setLoadingTids}
            setDeletedTrplId={setDeletedTrplId}
            constant={constant || disableTrplEditing}
          />
          :
          <div>
            <CreateTrplBtn
              rst={rst}
              trpl={trpl}
              trplIndex={0}
              classes={classes}
              setTrpl={setTrpl}
              isNewNode={isNewNode}
              ancestorId={ancestorId}
              loadingTids={loadingTids}
              deletedTids={deletedTids}
              isAnotherNode={isAnotherNode}
              setLoadingTids={setLoadingTids}
              resetDeletedTrplId={resetDeletedTrplId}
              updateDataOnRestoreTrpl={updateDataOnRestoreTrpl}
            />
          </div>
        }
    </div>
  );
};
